// ADV-264 — Bestellstatus of one order: the five steps (Figma "Konto / Bestellstatus Schritt")
// and the progress track under them ("Konto / Fortschrittsbalken"). Desktop shows each step's
// description; the mobile frame (≤1086px here) shows the compact row without descriptions.
import * as React from 'react';
import stepOrder from './icons/step-order.svg';
import stepPreparation from './icons/step-preparation.svg';
import stepRegistration from './icons/step-registration.svg';
import stepDelivery from './icons/step-delivery.svg';
import stepHandover from './icons/step-handover.svg';
import checkDone from './icons/check-done.svg';
import checkDoneMobile from './icons/check-done-mobile.svg';
const STEP_ICON = {
    order_received: stepOrder,
    preparation: stepPreparation,
    registration: stepRegistration,
    delivery: stepDelivery,
    pick_up: stepDelivery,
    handing_over: stepHandover,
};
const OrderSteps = ({ steps, t }) => (React.createElement("div", { className: "ao-steps-wrap" },
    React.createElement("ol", { className: steps.some(({ state }) => state === 'done') ? 'ao-steps ao-steps--has-done' : 'ao-steps' }, steps.map(({ key, state }) => {
        const label = t(`DealerDashboardPage:orderStatus.selector_status_${key}`);
        return (React.createElement("li", { key: key, className: `ao-step ao-step--${state}`, "aria-current": state === 'current' ? 'step' : undefined },
            React.createElement("span", { className: "ao-step-ic" },
                React.createElement("img", { className: "ao-step-img", src: STEP_ICON[key], alt: "" })),
            React.createElement("span", { className: "ao-step-chip" },
                state === 'done' ? (React.createElement(React.Fragment, null,
                    React.createElement("img", { className: "ao-step-check ao-desktop-only", src: checkDone, alt: "" }),
                    React.createElement("img", { className: "ao-step-check ao-mobile-only", src: checkDoneMobile, alt: "" }))) : null,
                React.createElement("span", { className: "ao-step-label ao-desktop-only" }, label),
                React.createElement("span", { className: "ao-step-label ao-mobile-only" }, key === 'order_received' ? t('MyOrderPage:orders.stepOrderedShort') : label)),
            React.createElement("span", { className: "ao-step-desc" }, t(`DealerDashboardPage:orderStatus.selector_status_${key}_desc`))));
    })),
    React.createElement("div", { className: "ao-track", "aria-hidden": "true" }, steps.map(({ key, state }) => (React.createElement("span", { key: key, className: `ao-mark ao-mark--${state}` },
        React.createElement("span", { className: "ao-mark-dot" })))))));
export default OrderSteps;
